/** Default reserve duration when the user leaves the field blank (hours). */
export const DEFAULT_RESERVE_HOURS = 2;

/** Minimum reserve duration for legal / video-remote-legal service types (hours). */
export const LEGAL_MIN_RESERVE_HOURS = 3;

/** Minimum reserve duration for all other interpreting jobs (hours). */
export const STANDARD_MIN_RESERVE_HOURS = 2;

const LEGAL_SERVICE_TYPE_CODES = new Set(['legal', 'video']);

export function isLegalOrVideoLegalServiceType(serviceTypeCodeOrName) {
  if (!serviceTypeCodeOrName) return false;
  const normalized = String(serviceTypeCodeOrName).trim().toLowerCase();
  if (LEGAL_SERVICE_TYPE_CODES.has(normalized)) return true;
  if (normalized.includes('video remote interpretation (legal)')) return true;
  return normalized === 'legal';
}

export function isCourtCertifiedInterpreterType(interpreterTypeCodeOrName) {
  if (!interpreterTypeCodeOrName) return false;
  const normalized = String(interpreterTypeCodeOrName).trim().toLowerCase();
  return normalized === 'court_certified' || normalized.includes('court certified');
}

export function getMinimumReserveHours(serviceTypeCodeOrName, interpreterTypeCodeOrName) {
  if (
    isLegalOrVideoLegalServiceType(serviceTypeCodeOrName) ||
    isCourtCertifiedInterpreterType(interpreterTypeCodeOrName)
  ) {
    return LEGAL_MIN_RESERVE_HOURS;
  }
  return STANDARD_MIN_RESERVE_HOURS;
}

export function getDefaultReserveHours(serviceTypeCodeOrName, interpreterTypeCodeOrName) {
  return getMinimumReserveHours(serviceTypeCodeOrName, interpreterTypeCodeOrName);
}

/**
 * @param {string|number|null|undefined} serviceTypeId
 * @param {Array<{ id: number|string, code?: string, name?: string }>} serviceTypes
 * @param {string|null|undefined} frontendServiceType
 */
export function resolveServiceTypeForReserveRules(
  serviceTypeId,
  serviceTypes = [],
  frontendServiceType = null
) {
  if (serviceTypeId != null && serviceTypes.length > 0) {
    const match = serviceTypes.find((st) => String(st.id) === String(serviceTypeId));
    if (match) return match.code || match.name || null;
  }
  if (frontendServiceType === 'video') return 'video';
  return frontendServiceType || null;
}

export function resolveReserveHours(reserveHours, serviceTypeCodeOrName, interpreterTypeCodeOrName) {
  const minHours = getMinimumReserveHours(serviceTypeCodeOrName, interpreterTypeCodeOrName);
  if (reserveHours === '' || reserveHours == null || Number.isNaN(Number(reserveHours))) {
    return minHours;
  }
  return Math.max(Number(reserveHours), minHours);
}
